module.exports = __webpack_public_path__ + "app/assets/images/man9-90263f6f88cbcd6b574bdf1932eca363.jpg";